/* ubra-miro-list.js — "Add to my list" for the MiRO enquiry range.
   ---------------------------------------------------------------
   MiRO products are Shopify PAGES, not Products. They have no variant and no
   cart, deliberately: MiRO delivery is quoted per order by weight and
   dimensions, so a checkout could not price it. This builds a list in the
   visitor's browser instead and posts it through the store contact form.

   Nothing here touches the cart, the Products API or Make.com.

   Pairs with snippets/ubra-miro-list.liquid. Rendered on every page from
   layout/theme.liquid, but stays completely dormant unless the visitor has
   items on a list or is on a page that has an .mp-add button.            */
(function () {
  "use strict";
  var KEY = "ubra-miro-list-v1";          // separate from ubra-finder-v2 on purpose:
                                          // clearing the Finder quiz must not empty a list
  var list = load();

  function load() {
    try { return JSON.parse(localStorage.getItem(KEY) || "{}") || {}; }
    catch (e) { return {}; }
  }
  function save() {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
  }
  function el(id) { return document.getElementById(id); }
  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  }
  function rands(n) { return "R " + Number(n || 0).toLocaleString("en-ZA"); }
  function count() { var n = 0; for (var k in list) n += list[k].qty; return n; }
  function total() { var t = 0; for (var k in list) t += list[k].price * list[k].qty; return t; }

  /* ---- reading a product off the page ----------------------------------
     The imported pages carry only data-uid on the button, so the part number,
     title and price are read back out of the rendered page. Verified against
     the live markup: .mp-pn holds "PN · Brand", .mp-price starts with the
     rands figure, and the H1 is the page title. If a future generator ever
     adds data-pn/data-title/data-price to the button, those win. */
  function firstText(node) {
    if (!node) return "";
    for (var i = 0; i < node.childNodes.length; i++) {
      if (node.childNodes[i].nodeType === 3) {
        var t = node.childNodes[i].nodeValue.trim();
        if (t) return t;
      }
    }
    return (node.textContent || "").trim();
  }
  function readProduct(btn) {
    var box = btn.closest(".miro-product") || document;
    var pn = btn.getAttribute("data-pn");
    var title = btn.getAttribute("data-title");
    var price = btn.getAttribute("data-price");

    if (!title) {
      var h1 = document.querySelector("h1");
      title = h1 ? h1.textContent.trim() : document.title;
    }
    if (!pn) {
      var pnEl = box.querySelector(".mp-pn");
      pn = pnEl ? firstText(pnEl).split("·")[0].trim() : "";
    }
    if (!price) {
      var pEl = box.querySelector(".mp-price");
      var raw = pEl ? firstText(pEl) : "";
      var m = raw.replace(/ /g, " ").match(/R\s*([\d\s.,]*\d)/);
      price = m ? m[1].replace(/[\s,]/g, "") : "0";
    }
    return {
      pn: pn || "",
      title: title || "",
      price: parseFloat(price) || 0,
      url: location.pathname
    };
  }

  /* ---- add / remove ---------------------------------------------------- */
  function toggle(btn) {
    var uid = btn.getAttribute("data-uid");
    if (!uid) return;
    if (list[uid]) {
      delete list[uid];
      btn.classList.remove("is-on");
      btn.textContent = "Add to my list";
    } else {
      var p = readProduct(btn);
      p.qty = 1;
      list[uid] = p;
      btn.classList.add("is-on");
      btn.textContent = "On your list";
    }
    save();
    paint();
  }

  function markButtons() {
    var btns = document.querySelectorAll(".mp-add");
    for (var i = 0; i < btns.length; i++) {
      var uid = btns[i].getAttribute("data-uid");
      if (uid && list[uid]) {
        btns[i].classList.add("is-on");
        btns[i].textContent = "On your list";
      }
    }
  }

  /* ---- the floating button and the drawer ------------------------------ */
  function paint() {
    var fab = el("miroFab"), n = count();
    if (!fab) return;
    fab.hidden = n === 0;
    var c = el("miroFabN");
    if (c) c.textContent = n;
    if (el("miroPanel") && !el("miroPanel").hidden) renderPanel();
  }

  function renderPanel() {
    var body = el("miroItems");
    if (!body) return;
    var ids = Object.keys(list);
    if (!ids.length) {
      body.innerHTML = '<p class="miro-empty">Nothing on your list yet.</p>';
    } else {
      body.innerHTML = ids.map(function (uid) {
        var it = list[uid];
        return '<div class="miro-li">' +
          '<div class="miro-li-t"><a href="' + esc(it.url) + '">' + esc(it.title) + '</a>' +
            '<span class="miro-li-m">' + esc(it.pn) + ' · ' + rands(it.price) + ' each</span></div>' +
          '<div class="miro-li-q">' +
            '<button type="button" data-step="-1" data-uid="' + esc(uid) + '" aria-label="One fewer">−</button>' +
            '<span>' + it.qty + '</span>' +
            '<button type="button" data-step="1" data-uid="' + esc(uid) + '" aria-label="One more">+</button>' +
          '</div>' +
          '<button type="button" class="miro-rm" data-rm="' + esc(uid) + '">remove</button>' +
        '</div>';
      }).join("");
    }
    var t = el("miroTotal");
    if (t) t.textContent = rands(total());
    var send = el("miroSend");
    if (send) send.disabled = ids.length === 0;
  }

  function openPanel(open) {
    var p = el("miroPanel"), s = el("miroScrim");
    if (!p) return;
    p.hidden = !open;
    if (s) s.hidden = !open;
    document.documentElement.style.overflow = open ? "hidden" : "";
    if (open) renderPanel();
  }

  /* ---- compose the list into the hidden field before submit ------------- */
  function composeBody() {
    var lines = ["MiRO enquiry list — built on the product pages", ""];
    var t = 0;
    Object.keys(list).forEach(function (uid) {
      var it = list[uid];
      t += it.price * it.qty;
      lines.push((it.pn ? it.pn + "  |  " : "") + it.title);
      lines.push("   " + it.qty + " x R" + it.price.toLocaleString("en-ZA") +
                 " = R" + (it.price * it.qty).toLocaleString("en-ZA") +
                 "   [" + uid + "]");
      lines.push("   " + location.origin + it.url);
    });
    lines.push("");
    lines.push("Goods total: R" + t.toLocaleString("en-ZA"));
    lines.push("Delivery: to be quoted.");
    return lines.join("\n");
  }

  /* ---- wire up --------------------------------------------------------- */
  function init() {
    markButtons();

    document.addEventListener("click", function (e) {
      var add = e.target.closest(".mp-add");
      if (add) { e.preventDefault(); toggle(add); return; }

      var open = e.target.closest("#miroFab");
      if (open) { openPanel(true); return; }

      if (e.target.closest("#miroClose") || e.target.closest("#miroScrim")) {
        openPanel(false); return;
      }

      var step = e.target.closest("[data-step]");
      if (step) {
        var uid = step.getAttribute("data-uid");
        if (list[uid]) {
          list[uid].qty = Math.max(1, list[uid].qty + parseInt(step.getAttribute("data-step"), 10));
          save(); renderPanel(); paint();
        }
        return;
      }

      var rm = e.target.closest("[data-rm]");
      if (rm) {
        delete list[rm.getAttribute("data-rm")];
        save(); renderPanel(); paint(); markButtonsOff(rm.getAttribute("data-rm"));
        return;
      }
    });

    var form = el("miroForm");
    if (form) {
      form.addEventListener("submit", function () {
        var hidden = el("miroBody");
        if (hidden) hidden.value = composeBody();
        try { sessionStorage.setItem("ubra-miro-sent", "1"); } catch (e) {}
      });
    }

    // Shopify returns to this page with ?contact_posted=true after a successful send
    if (/[?&]contact_posted=true/.test(location.search)) {
      var sent = false;
      try { sent = sessionStorage.getItem("ubra-miro-sent") === "1"; } catch (e) {}
      if (sent) {
        list = {};
        save();
        try { sessionStorage.removeItem("ubra-miro-sent"); } catch (e) {}
        var ok = el("miroThanks");
        if (ok) { ok.hidden = false; openPanel(true); }
      }
    }

    paint();
  }

  function markButtonsOff(uid) {
    var b = document.querySelector('.mp-add[data-uid="' + uid + '"]');
    if (b) { b.classList.remove("is-on"); b.textContent = "Add to my list"; }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else { init(); }
})();

/* ubra-miro-gallery -- make the product thumbnails clickable.
   ----------------------------------------------------------
   The imported pages render the gallery as plain <img> tags with no
   behaviour, deliberately: the markup has to work for a crawler with
   scripting off, so the pictures are real images in the page rather than a
   carousel assembled in the browser. That is right for search and wrong for
   a person, who quite reasonably clicks a thumbnail and expects it to open.

   This adds the missing half. On load it moves the main picture into the
   thumbnail strip as well, so every image is selectable and none is stranded
   in the viewer slot, then swaps the main picture on click. Nothing here
   touches the list, the cart or Make.com, and with scripting off the page
   still shows every image exactly as before.                              */
(function () {
  "use strict";

  function init() {
    var strip = document.querySelector(".mp-gallery");
    var mainP = document.querySelector(".mp-img");
    if (!strip || !mainP) return;
    var main = mainP.querySelector("img");
    if (!main) return;

    // The main picture is not in the strip, so put a thumbnail of it in front.
    // Cloning a strip thumbnail keeps the inline styling identical.
    var model = strip.querySelector("img");
    if (model) {
      var first = model.cloneNode(false);
      first.src = main.getAttribute("src");
      first.alt = main.getAttribute("alt") || "";
      strip.insertBefore(first, strip.firstChild);
    }

    var thumbs = [].slice.call(strip.querySelectorAll("img"));
    if (thumbs.length < 2) return;

    function select(t) {
      main.src = t.getAttribute("src");
      main.alt = t.getAttribute("alt") || main.alt;
      thumbs.forEach(function (o) {
        var on = o === t;
        o.setAttribute("aria-current", on ? "true" : "false");
        o.classList.toggle("is-on", on);
      });
    }

    thumbs.forEach(function (t, i) {
      t.classList.add("mp-thumb");
      t.setAttribute("role", "button");
      t.setAttribute("tabindex", "0");
      t.addEventListener("click", function () { select(t); });
      t.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") {
          e.preventDefault();
          select(t);
        }
      });
      if (i === 0) { t.setAttribute("aria-current", "true"); t.classList.add("is-on"); }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else { init(); }
})();
